import HeroBg from "public/designAndDeployment/network-design&deploy.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Compare Our Plans",
    link: "comparison",
  },
  button2: {
    label: "Build Your Network with Experts",
    link: "contact-us",
  },
  title: "Expert-Led Network Design and Seamless Deployment",
  desc: "Expert-driven network design and deployment for fast, reliable, and scalable infrastructure.",
  image: HeroBg,
};
